import { Container, Field, Input, Select, Card, Button } from '../../components/ui';
import MedicoHeader from './MedicoHeader';
import AccionesEditarEliminar from './AccionesEditarEliminar';
import './Medico.css';

const SERVICIOS = [
  { id: 1, nombre: 'Consulta cardiológica', tipo: 'Especialidad', duracion: '30 min', precio: '$ 9.000' },
  { id: 2, nombre: 'Electrocardiograma', tipo: 'Práctica', duracion: '20 min', precio: '$ 6.500' },
  { id: 3, nombre: 'Control post-operatorio', tipo: 'Especialidad', duracion: '30 min', precio: '$ 8.000' },
];

export default function MedicoServicios() {
  return (
    <Container>
      <MedicoHeader titulo="Mis servicios" />

      <div className="medico-section-head" style={{ marginTop: 'var(--space-5)' }}>
        <h2 style={{ margin: 0 }}>Servicios que ofrecés</h2>
      </div>

      <div className="medico-table-wrap" style={{ marginTop: 12 }}>
        <table className="medico-table">
          <thead>
            <tr><th scope="col">Servicio</th><th scope="col">Tipo</th><th scope="col">Duración</th><th scope="col">Precio base</th><th scope="col">Acciones</th></tr>
          </thead>
          <tbody>
            {SERVICIOS.map((s) => (
              <tr key={s.id}>
                <td>{s.nombre}</td><td>{s.tipo}</td><td>{s.duracion}</td><td>{s.precio}</td>
                <td><AccionesEditarEliminar /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2 style={{ marginTop: 'var(--space-6)' }}>Nuevo servicio</h2>
      <Card as="form" onSubmit={(e) => e.preventDefault()}>
        <div className="medico-cols">
          <Field label="Nombre del servicio" htmlFor="nombre"><Input id="nombre" placeholder="Ej. Consulta cardiológica" /></Field>
          <Field label="Tipo" htmlFor="tipo"><Select id="tipo"><option>Especialidad</option><option>Práctica</option></Select></Field>
          <Field label="Duración (min)" htmlFor="duracion"><Input id="duracion" type="number" defaultValue={30} min={10} step={5} /></Field>
          <Field label="Precio base ($)" htmlFor="precio"><Input id="precio" type="number" defaultValue={9000} min={0} step={500} /></Field>
        </div>
        <div className="medico-actions" style={{ justifyContent: 'flex-end' }}>
          <Button type="reset" variant="secondary">Limpiar</Button>
          <Button type="submit">Guardar servicio</Button>
        </div>
      </Card>
    </Container>
  );
}